import React from "react";
import { Toast } from "react-bootstrap";
import { IoIosCloudUpload } from "react-icons/io";
import "bootstrap/dist/css/bootstrap.min.css"; // Make sure you have this

const SuccessMsg = ({ head, message, show, setShow }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed", // Viewport-based
        top: "50%", // Vertical center of screen
        left: "50%", // Horizontal center
        transform: "translate(-50%, -50%)", // Perfect centering
        zIndex: 1055, // Above most Bootstrap elements
      }}
    >
      <Toast
        show={show}
        onClose={() => setShow(false)}
        delay={3000}
        autohide
        bg="success"
      >
        <Toast.Header className="bg-success text-white">
          <strong className="me-auto">
            <IoIosCloudUpload /> {head}
          </strong>
        </Toast.Header>
        <Toast.Body className="bg-success-subtle text-success-emphasis">
          <b>{message}</b>
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default SuccessMsg;
